import React from 'react';

const MembersTab = ({
  filteredMembers, loading, searchTerm, setSearchTerm,
  filters, setFilters, clearFilters, currentUser,
  toggleFavorite, isFavorited, isShortlisted, addToShortlist,
  startNewMessage, navigate
}) => (
  <div className="members-section" data-testid="browse-section">
    <div className="section-header">
      <h2>Available Members</h2>
      <p>Connect with verified pensioners to share housing costs</p>
    </div>
    <div className="search-filter-bar">
      <div className="search-input-wrapper">
        <input type="text" placeholder="Search by name or email..." value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} className="search-input" data-testid="member-search-input" />
      </div>
      <div className="filter-controls">
        <select value={filters.housingType} onChange={(e) => setFilters({...filters, housingType: e.target.value})}
          className="filter-select-sm" data-testid="housing-type-filter">
          <option value="">All Housing Types</option>
          <option value="single_female">Female Community</option>
          <option value="single_male">Male Community</option>
          <option value="couples">Couples Community</option>
        </select>
        <select value={filters.state} onChange={(e) => setFilters({...filters, state: e.target.value})}
          className="filter-select-sm" data-testid="state-filter">
          <option value="">All States</option>
          <option value="NSW">NSW</option><option value="VIC">VIC</option><option value="QLD">QLD</option>
          <option value="SA">SA</option><option value="WA">WA</option><option value="TAS">TAS</option>
          <option value="NT">NT</option><option value="ACT">ACT</option>
        </select>
        {(searchTerm || filters.housingType || filters.state) && (
          <button className="clear-filters-btn-sm" onClick={clearFilters} data-testid="clear-filters-btn">Clear</button>
        )}
      </div>
    </div>
    <p className="results-count">{filteredMembers.filter(m => m.user_id !== currentUser?.user_id).length} members found</p>
    {loading ? (
      <div className="loading">Loading members...</div>
    ) : filteredMembers.length === 0 ? (
      <p className="no-members">No members found matching your criteria</p>
    ) : (
      <div className="members-grid">
        {filteredMembers.filter(m => m.user_id !== currentUser?.user_id).map((member) => (
          <div key={member.user_id} className="member-card" data-testid={`member-card-${member.user_id}`}>
            <div className="member-avatar">
              {member.picture ? (
                <img src={member.picture} alt={member.username || member.name} />
              ) : (
                <div className="avatar-placeholder">{(member.username || member.name).charAt(0)}</div>
              )}
            </div>
            <div className="member-info">
              <h3 style={{ cursor: 'pointer', color: '#2563eb' }} onClick={() => navigate(`/members/${member.user_id}`)} data-testid={`member-name-${member.user_id}`}>
                {member.username || member.name}
              </h3>
              <p className="member-date">Member since {new Date(member.created_at).toLocaleDateString()}</p>
            </div>
            <div className="member-actions">
              <button onClick={() => toggleFavorite(member.user_id, 'member')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: isFavorited(member.user_id, 'member') ? '#ef4444' : '#d1d5db', marginRight: '8px' }}
                data-testid={`fav-member-btn-${member.user_id}`}
                title={isFavorited(member.user_id, 'member') ? 'Remove from favorites' : 'Add to favorites'}>
                {isFavorited(member.user_id, 'member') ? '\u2665' : '\u2661'}
              </button>
              <button className="btn btn-sm" onClick={() => startNewMessage(member.user_id, member.username || member.name)}
                style={{ marginRight: '8px', fontSize: '12px', padding: '4px 10px' }} data-testid={`msg-member-btn-${member.user_id}`}>
                Message
              </button>
              {isShortlisted(member.user_id) ? (
                <button className="btn btn-secondary" disabled data-testid={`shortlisted-btn-${member.user_id}`}>Shortlisted</button>
              ) : (
                <button className="btn btn-primary" onClick={() => addToShortlist(member.user_id)} data-testid={`add-shortlist-btn-${member.user_id}`}>
                  Add to Shortlist
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default MembersTab;
